const pictureExtension = ["png", "jpg", "jpeg", "gif", "bmp"];

export default pictureExtension;
